<template>
    <v-container fluid fill-height class="text-center d-flex align-center justify-center editProfileJobmule"
        style="min-width:280px;">

        <v-form style="min-width:300px;" ref="form" v-model="valid" lazy-validation>

            <v-text-field v-model="profile.fld_name" label="Azienda" readonly></v-text-field>

            <v-text-field v-model="profile.username" label="Utente" readonly></v-text-field>

            <v-text-field v-model="profile.mail" :rules="emailRules" label="E-mail" required></v-text-field>

            <span class="files">
                <label style="font-weight: bold;margin-right: 164px;">Logo (Dim. Max. 200px X 38px)</label>
                <input type="file" id="input-file-logo" name="logo" accept=".png" class="dropify" data-max-width="6610"
                    data-max-height="6200" style="margin-top:20px" />
            </span>

            <div class="padding" style="min-height:100px;"></div>
        </v-form>





    </v-container>
</template>

<script>
const $ = window.$;

import apiprofile from "../utils/profile/apiprofile";
import apiusers from "../utils/users/apiusers";

import {
    bus
} from "../main";
import router from ".././router";
//import $ from 'jquery';
import _ from 'lodash';

export default {

    computed: {

        filteredGruppi() {
            return _.orderBy(this.gruppi.filter(item => {
                if (!this.searchGruppi) return this.gruppi;
                // console.log ( "item", item );
                return (item.nome.toLowerCase().includes(this.searchGruppi.toLowerCase()));
            }), 'headline')
        },

        filteredDipendenti() {
            return _.orderBy(this.dipendenti.filter(item => {
                if (!this.searchDipendenti) return this.dipendenti;
                return (item.fld_name.toLowerCase().includes(this.searchDipendenti.toLowerCase()));
            }), 'headline')
        },

        filteredAziende() {
            return _.orderBy(this.aziende.filter(item => {
                if (!this.search) return this.aziende;
                return (item.toLowerCase().includes(this.search.toLowerCase()));
            }), 'headline')
        },

    },

    destroyed() {
        this.$root.$children[0].bnavbuttons = [];

        bus.$off("bottomIconClickEvent");
        //window.removeEventListener("scroll", this.onScroll, false);

        //document.querySelector('#btn_add_tms').removeEventListener('click' , this.btn_add_tms_click);
    },

    mounted: function () {

        /*     let self = this;
            fetch('https://jsonplaceholder.typicode.com/posts')
              .then(response => response.json())
              .then(json => self.$data.items = json) */

        //var res = apiprofile.getProfile(1,2);

        var pointerVue = this;

        this.$root.$children[0].showAziendaSelezionata = false;

        //this.$root.$children[0].checkLogout();

        this.isAgila = window.$cookies.get("is_agila");


        this.dipendenti = this.$root.$children[0].dipendenti;

        this.gruppi = this.$root.$children[0].gruppi;

        this.aziende = this.$root.$children[0].aziende;
        this.globalArrAziende = this.$root.$children[0].globalArrAziende;

        this.setupButtons();
        setTimeout(() => {
            this.syncProfile();

        }, 100);
        // console.log (res);

        bus.$on("bottomIconClickEvent", (data) => {
            //this.header = data;
            console.log(data);
            switch (data) {

                case "btn_aziende":
                    //this.admindialog = true ;
                    this.$root.$children[0].showProgress = true;

                    setTimeout(() => {
                        this.sheetAziende = true;
                        this.$root.$children[0].showProgress = false;

                    }, 300);
                    break;

                case "btn_add_tms":

                    this.validate();

                    break;

                case "btn_exit":
                    //alert("btn_add_x");
                    router.push({
                        path: "/dash"
                    });
                    break;


                case "btn_delete_profile":

                    this.deleteAccountAction();

                    break;

                case "btn_change_psw":

                    router.push({
                        path: "/changepasswordprofile/"
                    });


                    break;

                case "btn_create_qr":

                    this.createQRUser();


                    break;




                default:
                    break;
            }
        });

        $(document).ready(function () {

            $('#input-file-logo').on('change', function () {


                console.log("change");




                pointerVue.logoChanged = 1;





            });

            $('body').on('input', '#cellulare', function () {

                let value = $("#cellulare").val().replace(/\D/g, "");

                value = value.replace(/\D/g, "");

                // Applica la formattazione: 3-3-2-2
                let formatted = "";
                if (value.length > 0) {
                    formatted += value.substring(0, 3);
                }
                if (value.length > 3) {
                    formatted += " " + value.substring(3, 6);
                }
                if (value.length > 6) {
                    formatted += " " + value.substring(6, 8);
                }
                if (value.length > 8) {
                    formatted += " " + value.substring(8, 10);
                }

                $("#cellulare").val(formatted)

            });


        });

        this.$nextTick(() => {
            const oggDrop = $('.dropify').dropify({
                messages: {
                    default: 'Drag',
                    replace: '',
                    remove: 'Rimuovi',
                    error: 'File troppo grande'
                }
            });

            $(".dropify-clear").html("<img src='https://app.smart-book.it/public/_lib/img/icons8-cestino-64.png' />");
            $(".dropify-render").append("<img>");

            oggDrop.on('dropify.afterClear', function (event, element) {

                console.log(event);
                console.log(element);


                pointerVue.logoChanged = 1;

            });


        });

        this.setupButtons();
    },
    data: () => ({

        logoChanged: 0,

        isAgila: 0,

        currDipendenteObj: {},
        aziende: [],
        dipendenti: [],
        currAzienda: "",

        sheetAziende: false,
        sheetDipendenti: false,
        searchDipendenti: "",
        search: "",

        showPicker: false,
        profile: {},
        valid: true,
        initials: "",
        namesurname: "",
        iban: "",
        cellulare: "",
        codicefiscale: "",
        codicefiscaleRules: [
            (v) => !!v || "Codice fiscale is required",
            (v) => (v && v.length <= 16) || "Codice fiscale must be less than 16 characters",
        ],
        cellulareRules: [
            (v) => !!v || "Phone number is required",
            (v) => (v && v.length <= 30) || "Phone number must be less than 15 characters",
        ],
        genRules: [
            (v) => !!v || "Field required",

        ],
        ibanRules: [
            (v) => !!v || "Iban is required",
            (v) => (v && v.length <= 30) || "Iban must be less than 30 characters",
        ],
        email: "",
        emailRules: [
            (v) => !!v || "Valore richiesto",
            (v) => /.+@.+\..+/.test(v) || "Valore non valido",
        ],
        select: null,
        items: ["Item 1", "Item 2", "Item 3", "Item 4"],
        checkbox: false,
    }),

    methods: {

        getUrlImageButton: function (nome_metodo) {

            let result = "";

            if (location.hostname == "localhost") {
                result = location.protocol + "//emtool.local/";
            }

            if (location.hostname != "localhost") {

                result = $(location).attr('protocol') + "//" + $(location).attr('hostname') + "/";

            }

            return result + nome_metodo;

        },


        getUrlDomainGo: function (nome_metodo) {

            let result = "";

            if (location.hostname == "localhost") {
                result = "http://localhost:4007/";
            }

            if (location.hostname != "localhost") {

                result = "https://filestransfer.it:4007/";

            }

            return result + nome_metodo;

        },


        formattaNumeroNazionale(numero) {
            // Rimuove tutti gli spazi, punti, slash ecc.
            numero = numero.replace(/[\s./-]/g, '').trim();

            // Mantieni solo il '+' iniziale (se presente) e rimuovi tutti gli altri caratteri non numerici
            if (numero.startsWith('+')) {
                numero = '+' + numero.slice(1).replace(/\D/g, '');
            } else {
                numero = numero.replace(/\D/g, '');
            }

            // Normalizza "00" in "+"
            if (numero.startsWith('00')) {
                numero = '+' + numero.slice(2);
            }

            const prefissiValidi = [
                "1", "7", "20", "27", "30", "31", "32", "33", "34", "36", "39", "40",
                "41", "43", "44", "45", "46", "47", "48", "49", "51", "52", "53", "55",
                "56", "57", "58", "60", "61", "62", "63", "64", "65", "66", "81", "82",
                "84", "86", "90", "91", "92", "93", "94", "95", "98",
            ];

            let prefissoInternazionale = '';
            let numeroNazionale = '';

            if (numero.startsWith('+')) {
                for (const p of prefissiValidi) {
                    if (numero.startsWith('+' + p)) {
                        prefissoInternazionale = '+' + p;
                        numeroNazionale = numero.slice(prefissoInternazionale.length);
                        break;
                    }
                }
            }

            // Caso speciale per numeri italiani senza '+39'
            if (!prefissoInternazionale) {
                if (numero.startsWith('39') && numero.length >= 11) {
                    prefissoInternazionale = '+39';
                    numeroNazionale = numero.slice(2);
                } else if (numero.length === 10) {
                    numeroNazionale = numero;
                } else {
                    return numero; // formato non valido
                }
            }

            if (numeroNazionale.length < 6) {
                return numero;
            }

            // FORMATO ITALIANO: 3 + 3 + 2 + 2
            if (prefissoInternazionale === '+39' || numero.length === 10) {
                const blocchi = [
                    numeroNazionale.slice(0, 3),
                    numeroNazionale.slice(3, 6),
                    numeroNazionale.slice(6, 8),
                    numeroNazionale.slice(8, 10)
                ].filter(Boolean);
                return (prefissoInternazionale ? prefissoInternazionale + ' ' : '') + blocchi.join(' ');
            }

            // Altrimenti, formatta in gruppi di 3 con punti
            const prefissoNazionale = numeroNazionale.slice(0, 3);
            const parteRestante = numeroNazionale.slice(3);
            const gruppi = [];
            for (let i = 0; i < parteRestante.length; i += 3) {
                gruppi.push(parteRestante.slice(i, i + 3));
            }
            const restoFormattato = gruppi.join('.');
            return `${prefissoInternazionale} ${prefissoNazionale} ${restoFormattato}`;
        },

        createQRUser: async function () {

            var that = this;

            var ids = window.$cookies.get("user_id");

            // $(".val_status").each(function (index) {

            //     console.log(index);

            //     if ($(this).prop("checked")) {

            //         if (ids != "") {
            //             ids = ids + ",";
            //         }
            //         ids = ids + $(this).attr("data-id");
            //     }

            // });

            // console.log("IDS SEL:", ids);

            var v_token = window.$cookies.get("token");

            that.showSpinner = true;
            that.$root.$children[0].showProgress = true;

            var response = await apiusers.validateCreateQRCode(
                ids,
                v_token
            ).then(async (res) => {

                console.log("res from validateCreateQRCode", res);

                var response2 = await apiusers.createQRCodeSingle(
                    ids,
                    v_token
                ).then((res2) => {

                    console.log(response2);

                    that.$root.$children[0].showProgress = false;
                    console.log("res from createQRCodeSingle", res2);

                    that.$swal({
                        icon: "success",
                        text: "QRCode Generato Con Successo",
                        showConfirmButton: false,
                        timer: 2000
                    });


                    var file_path = res2.data.ValUrl;
                    var a = document.createElement('A');
                    a.href = file_path;
                    a.target = "_blank";
                    a.download = file_path.substr(file_path.lastIndexOf('/') + 1);
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);



                }).catch(err2 => {
                    that.$root.$children[0].showProgress = false;
                    console.log(err2);
                    var msg = err2.response.data.Error;

                    that.$swal({
                        icon: "error",
                        text: msg,
                        showConfirmButton: false,
                        timer: 8000
                    });
                    console.log("Errori", "Non è stato possibile eliminare i dati");
                    console.log("response", response);

                }

                );







            }).catch(err => {
                that.$root.$children[0].showProgress = false;
                console.log(err);
                var msg = err.response.data.Error;

                that.$swal({
                    icon: "error",
                    text: msg,
                    showConfirmButton: false,
                    timer: 8000
                });
                console.log("Errori", "Non è stato possibile eliminare i dati");
                console.log("response", response);

            }

            );



        },




        getUrlDomain: function (nome_metodo) {

            let result = "";

            if (location.hostname == "localhost") {
                result = location.protocol + "//emtool.local/";
            }

            if (location.hostname != "localhost") {

                result = "https://companysupport.eu/";

            }

            return result + nome_metodo;

        },

        deleteAccountAction: function () {

            var that = this;

            console.log("PROFILE: ", that.profile);


            // this.showSpinner = true;

            //  var site_domain = "https://app.emtool.eu/";

            var spinner = $("#bspinner");
            var loginButton = $("#login-button");

            //var API_URL = this.getUrlDomain("api/resetAccount");
            var API_URL = this.getUrlDomainGo("resetAccountJobmule");


            var loginpar = window.$cookies.get("username");



            var imgBtnSi = this.getUrlImageButton("public/_lib/img/btn_si_jobmule.png");
            var imgBtnNo = this.getUrlImageButton("public/_lib/img/btn_no_jobmule.png");

            //  var that = this;
            this.$swal.fire({
                title: "Rimuovi Account",
                html: "Sei sicuro di voler rimuovere il tuo account ?",
                showCancelButton: true,
                // confirmButtonText: "<img title='Si' style='width:30px' src='https://app.emtool.eu/public/_lib/img/btn_si_emt.png' />",
                // cancelButtonText: "<img title='No' style='width:30px' src='https://app.emtool.eu/public/_lib/img/btn_no_emt.png' />",
                confirmButtonText: "<img title='Si' style='width:30px' src='" + imgBtnSi + "' />",
                cancelButtonText: "<img title='No' style='width:30px' src='" + imgBtnNo + "' />",

                customClass: {
                    cancelButton: 'order-1',
                    confirmButton: 'order-2',
                },


                /*  input: "text", */

                inputAttributes: {
                    autocapitalize: "off",
                },

                preConfirm: (username) => {
                    console.log(username);

                    // show spinner && disable button
                    spinner.removeClass("vhidden");
                    that.showSpinner = true;

                    loginButton.prop("disabled", true);

                    var body = {
                        loginpar: loginpar,
                        email: that.profile.mail,
                        method: "REMOVE_ACCOUNT",
                        context: window.context,
                    };

                    console.log(body);
                    // call the service

                    that.showSpinner = true;
                    that.$root.$children[0].showProgress = true;


                    $.ajax({
                        type: "POST",
                        url: API_URL,
                        data: body,
                        success: function (resultData) {

                            that.showSpinner = false;
                            that.$root.$children[0].showProgress = false;

                            // hide spinner && enable button
                            spinner.addClass("vhidden");
                            that.showSpinner = false;

                            loginButton.prop("disabled", false);

                            if (resultData.Result == "OK") {
                                var message;

                                if (resultData.send_type == "SMS") {
                                    message = "Verifica il tuo Sms";
                                } else {
                                    message = "Verifica la tua mail";
                                }

                                //open ok modal

                                that.$swal.fire({
                                    icon: "success",
                                    title: message,
                                    showConfirmButton: true,
                                    confirmButtonText: "<img title='Conferma' style='width:30px' src='https://app.emtool.eu/public/_lib/img/btn_confirm3_jobmule.png' />",
                                });

                                that.$root.$children[0].logout();

                            } else {
                                var errorMessage;

                                switch (resultData.Result) {
                                    case "USER_NOT_FOUND":
                                        errorMessage = "Utente non trovato";
                                        break;
                                    default:
                                        errorMessage = "Utente non trovato";
                                }

                                that.$swal.fire({
                                    text: errorMessage,
                                    icon: "error",
                                    showConfirmButton: false,
                                });

                                that.showSpinner = false;
                            }
                        },
                        error: function () {
                            // hide spinner && enable login button
                            spinner.addClass("vhidden");
                            loginButton.prop("disabled", false);
                            that.showSpinner = false;
                            //  errorHandler(event);
                        },
                    });
                },
            });
        },


        changeDip: function () {

            /*   var token = window.$cookies.get("token");
              var system = window.$cookies.get("system");
              var user_id = window.$cookies.get("user_id");

              if (this.currDipendenteObj.resourceid !== undefined) {
                  //alert (  this.currDipendenteObj.resourceid  );
                  system = this.currDipendenteObj.v_res_id;
                  token = this.currDipendenteObj.v_user;
                  user_id = this.currDipendenteObj.v_user_id;

              } */

            var selNameDip = "";
            for (const [key, dip] of Object.entries(this.dipendenti)) {
                console.log("key", key);
                if (parseInt(dip.resourceid) == this.currDipendente) {
                    this.currDipendenteObj = dip;
                    console.log("dip", dip);
                    selNameDip = dip.fld_name;

                }
            }

            this.$root.$children[0].curDipTop = selNameDip;

            // console.log(token, system, user_id);
            this.syncProfile();

        },
        manageClickDipendenti: function (dipendente) {
            this.sheetDipendenti = false;
            this.currDipendente = dipendente.resourceid;
            //  alert ( dipendente );
            // this.resetDay();
            this.changeDip();
            setTimeout(() => {
                // this.syncMonth();

            }, 100);
            /*   this.syncArrayDipendenti();
              console.log ("CurAzienda",this.currAzienda );
              console.log(this.dipendenti);

              this.sheetDipendenti = true ; */

        },

        syncArrayDipendenti: async function () {

            console.log(this.currDipendente);

            this.currDipendente = "";
            this.$root.$children[0].curDipTop = "";

            this.$root.$children[0].curDipOreTop = "";
            this.$root.$children[0].curDipOreTopLabel = "";

            //aziende
            var arrAziende = [];
            var arrDipendenti = [];

            var aziende = this.globalArrAziende; // Object.entries( this.monthArray.aziende  ) ;
            //   var aziende =   this.aziende  ;

            //console.log("Elenco aziende:", this.aziende);
            console.log("Elenco aziende:", aziende);

            // this.currAzienda
            //console.log ( "aziendeOK" , aziende );
            for (var az of aziende) {

                var currArAzienda = az[1].fld_name;
                console.log("az", az);
                arrAziende.push(az[1].fld_name);

                var dipArray = az[1].dipendenti;
                for (var dip of dipArray) {
                    //console.log ( dip.fld_name );
                    //  console.log ( dip );
                    if (currArAzienda == this.currAzienda) {
                        arrDipendenti.push(dip);

                    }
                }

            }
            //this.aziende = arrAziende;
            this.dipendenti = arrDipendenti;

        },

        manageClickAziende: async function (azienda) {

            this.currAzienda = azienda;
            await this.syncArrayDipendenti();

            console.log("CurAzienda", this.currAzienda);
            console.log(this.dipendenti);

            setTimeout(() => {
                this.sheetAziende = false;
                this.sheetDipendenti = true;
            }, 300);

        },

        manageClose: function () {

            this.setupButtons();
            this.sheetAziende = false;
            this.sheetEmpty = false;
            this.sheetDipendenti = false;
            this.sheetGruppi = false;

        },

        setupButtons: async function () {

            setTimeout(() => {
                // console.log ("here we go" , this.$root.$children[0].drawer ) ;
                //window.App.$children[0].setToolbar();
                //   this.$root.$children[0].setToolbar();




                var pulsantis = [


                    {
                        text: "Salva",
                        icon: "mdi-content-save",
                        link: "/timesheet",
                        id: "btn_add_tms",
                        disabled: false,
                        image: "https://app.emtool.eu/public/_lib/img/save_update_data-careers2.png",
                        title: "Salva",
                        width: 30

                    },


                ];

                pulsantis.push({
                    text: "Delete",
                    icon: "mdi-home-circle",
                    image: this.getUrlDomain("public/_lib/img/change_password-careers.png"),
                    link: "/info",
                    id: "btn_change_psw",
                    disabled: false,
                    title: "Cambio Password",
                    width: 23

                });

                pulsantis.push({
                    text: "Delete",
                    icon: "mdi-home-circle",
                    image: "https://app.emtool.eu/public/_lib/img/delete-careers2.png",
                    link: "/info",
                    id: "btn_delete_profile",
                    disabled: false,
                    title: "Elimina",
                    width: 30

                });













                this.$root.$children[0].bnavbuttons = pulsantis;


                setTimeout(() => {
                    //document.querySelector('#btn_add_tms').addEventListener('click',  this.btn_add_tms_click)
                    //this.$root.$children[0].$refs.btn_add_tms.$el.addEventListener('click', this.onClick);
                }, 100);

                // this.$root.$children[0].$refs.btn_add_tms[0].$el.addEventListener('click', this.onClick);
            }, 100);

        },

        /*       setupButtons: async function () {
        setTimeout(() => {
            var pulsantis = [{
                text: "Dashboard",
                icon: "mdi-home-circle",
                link: "/dash",
                id: "btn_exit",
                disabled: false,
            }, ];
            var a = window.$cookies.get("a");
            if (a == 'Y' || a == 'S') {
                pulsantis.push({
                    text: "",
                    icon: "mdi-message-plus",
                    link: "/dash",
                    id: "btn_aziende",
                    disabled: false,
                }, );
            }
            this.$root.$children[0].bnavbuttons = pulsantis;
        }, 100);
    },
*/


        saveProfile: async function () {

            console.log("PROFILE: ", this.profile);

            var username = window.$cookies.get("username");
            var token_system = window.$cookies.get("token_system");


            if (this.currDipendenteObj.resourceid !== undefined) {
                username = atob(this.currDipendenteObj.v_user);
                token_system = this.currDipendenteObj.way;

            }

            this.showSpinner = true;
            this.$root.$children[0].showProgress = true;

            var response;

            this.profile.name = this.profile.nome_utente;

            this.profile.tel_cell = this.profile.tel_cell.replace(/\s+/g, "");

            console.log(username, token_system);
            try {

                response = await apiprofile.setProfileNew(
                    username,
                    token_system,
                    this.profile,
                    1,
                    "emt"
                );
            } catch (error) {
                this.showSpinner = false;
                console.log(error);
            }

            this.showSpinner = false;
            this.$root.$children[0].showProgress = false;

            try {

                console.log(response.data.Result);

                this.$swal({
                    icon: "success",
                    text: "Dati salvati correttamente",
                    showConfirmButton: false,
                    timer: 2000
                });



            } catch (error) {
                console.log(error);
            }

            //  this.data.days = response.data ;
        },


        setProfileJobmule: async function () {

            console.log("PROFILE: ", this.profile);

            var username = window.$cookies.get("username");
            var token_system = window.$cookies.get("token_system");


            if (this.currDipendenteObj.resourceid !== undefined) {
                username = atob(this.currDipendenteObj.v_user);
                token_system = this.currDipendenteObj.way;

            }

            this.showSpinner = true;
            this.$root.$children[0].showProgress = true;

            var response;

            this.profile.email = this.profile.mail;

            console.log(username, token_system);
            try {

                response = await apiprofile.setProfileJobmule(
                    username,
                    token_system,
                    this.profile,
                    $("#input-file-logo")[0].files[0]
                );
            } catch (error) {
                this.showSpinner = false;
                console.log(error);
            }

            this.showSpinner = false;
            this.$root.$children[0].showProgress = false;

            try {

                console.log(response.data.Result);

                this.$swal({
                    icon: "success",
                    text: "Dati salvati correttamente",
                    showConfirmButton: false,
                    timer: 2000
                });



            } catch (error) {
                console.log(error);
            }

            //  this.data.days = response.data ;
        },




        syncProfile: async function () {
            /*  var token = window.$cookies.get("token");
             var system = window.$cookies.get("system"); */

            setTimeout(async () => {


                var username = window.$cookies.get("username");
                var token_system = window.$cookies.get("token_system");
                var v_token = window.$cookies.get("token");

                console.log("TOKEN SYSTEM", token_system);

                console.log("oki", this.currDipendenteObj);

                if (this.currDipendenteObj.resourceid !== undefined) {
                    //alert (  this.currDipendenteObj.resourceid  );
                    token_system = this.currDipendenteObj.way;
                    username = atob(this.currDipendenteObj.v_user);

                }


                //   console.log ( system );
                this.showSpinner = true;
                this.$root.$children[0].showProgress = true;



                var result;
                try {
                    // alert ( username + " +" + token_system );
                    result = await apiprofile.goGetProfileJobmule(
                        username,
                        token_system,
                        v_token
                    ).then((response) => {
                        // alert ("finshed");

                        console.log("response goGetProfileJobmule: ", response);
                        this.showSpinner = false;
                        this.$root.$children[0].showProgress = false;

                        try {


                            this.profile = response.data.Result;
                            this.profile.username = username;
                            this.profile.mail = response.data.Result.email;


                            if (response.data.UrlLogo != "") {

                                $('.dropify-render img').attr("src", response.data.UrlLogo);
                                $(".dropify-wrapper").addClass("has-preview");
                                $(".dropify-preview").show("slow");

                            }


                        } catch (error) {
                            console.log(error);
                            alert(error.message);
                        }

                        console.log(result);

                    });
                } catch (error) {
                    alert(error.message);

                    this.showSpinner = false;
                    this.$root.$children[0].showProgress = false;
                }

            }, 300);

            //  this.data.days = response.data ;
        },

        btn_add_tms_click() {
            console.log(1);
        },

        reply(par) {
            console.log(par);
        },

        validate() {

            var that = this;

            var res = this.$refs.form.validate();
            console.log(res);
            if (!res) {

                this.$swal({
                    icon: "error",
                    text: "Per favore verificare i dati",
                    confirmButtonText: "<img title='Conferma' style='width:30px' src='https://app.emtool.eu/public/_lib/img/btn_confirm3_emt.png' />",
                    cancelButtonText: "<img title='Annulla' style='width:30px' src='https://app.emtool.eu/public/_lib/img/btn_cancel3_emt.png' />",
                    customClass: {
                        cancelButton: 'order-1',
                        confirmButton: 'order-2',
                    }


                });
            } else {

                console.log("Profile: ", that.profile);
                console.log("logopresent: ", that.logoPresent);

                var errore = "";

                if (that.logoChanged == 1) {

                    if (errore == "") {
                        if ($("#input-file-logo")[0].files.length == 0) {
                            errore = "Specificare l'immagine del logo";
                        }
                    }

                    if (errore == "") {
                        if (that.logoPresent == 0) {
                            errore = "Specificare l'immagine del logo";
                        }
                    }

                    if (errore == "") {
                        if ($("#input-file-logo")[0].files.length > 0) {
                            var estensione22 = $("#input-file-logo")[0].files[0].name.split('.').pop().toLowerCase();
                            if (estensione22 != "png") {
                                errore = "Formati accettati PNG";
                            }
                        }
                    }

                    if (errore == "") {

                        const img = new Image();
                        img.src = URL.createObjectURL($("#input-file-logo")[0].files[0]);

                        img.onload = () => {


                            console.log("WIDTH: ", img.width);
                            console.log("HEIGHT: ", img.height);

                            if ((img.width > 200) || (img.height > 38)) {
                                errore = "Dimensione massima del logo 200px X 38px";
                            }

                            if (errore == "") {

                                console.log("ok");

                                this.setProfileJobmule();

                            }
                            else {

                                that.$swal({
                                    icon: "error",
                                    text: errore,
                                    confirmButtonText: "<img title='Conferma' style='width:30px' src='https://app.emtool.eu/public/_lib/img/btn_confirm3_jobmule.png' />",
                                });

                            }


                            URL.revokeObjectURL(img.src);
                        };

                    }
                    else {

                        that.$swal({
                            icon: "error",
                            text: errore,
                            confirmButtonText: "<img title='Conferma' style='width:30px' src='https://app.emtool.eu/public/_lib/img/btn_confirm3_jobmule.png' />",
                        });



                    }
                }


                if (that.logoChanged == 0) {


                    this.setProfileJobmule();

                }






                // if (this.isAgila == 0) {

                //     this.saveProfile();
                // }

                // if (this.isAgila == 1) {

                //     this.saveProfileWitoutRes();
                // }




            }
        },

        reset() {
            this.$refs.form.reset();
        },
        resetValidation() {
            this.$refs.form.resetValidation();
        },
    },
};
</script>

<style scoped>
.titlenewrow {
    justify-content: center;
    padding-top: 25px;
    padding-bottom: 30px;
    font-weight: bolder;

}

.v-sheet.v-card:not(.v-sheet--outlined) {
    box-shadow: none;
}
</style>

<style>
.editProfileJobmule .dropify-wrapper {
    height: 236px !important;
    width: 341px !important;
    margin-bottom: 20px;
    margin-left: 10px;
}

.editProfileJobmule .v-label {
    font-size: 11px !important;
    color: black !important;
    font-weight: bold !important;
}


.editProfileJobmule .v-input {
    font-size: 11px !important;
    padding: 10px !important;
    color: black !important;
    font-weight: bold !important;
}

.editProfileJobmule ion-select {
    font-size: 11px !important;
    color: black !important;
    font-weight: bold !important;
}
</style>